import _ from 'lodash';

import cleanUpResponse from '@/util/cleanUpResponse';

export default async function GetAllMFDCustomerOrderFormDataByOrderId(orderId) {
  const response = await $.soap({
    body: {
      GetAllMFDCustomerOrderFormDataByOrderId: {
        $xmlns: 'http://dla.mil/ems/bpm/order/order_form',
        OrderId: orderId
      }
    },
    blueprintArrays: ['GetAllMFDCustomerOrderFormDataByOrderIdResponse.FormData.GetAllMFDCustomerOrderFormDataByOrderIdResponse.tuple'],
    blueprint: {
      items: [
        'GetAllMFDCustomerOrderFormDataByOrderIdResponse.FormData.GetAllMFDCustomerOrderFormDataByOrderIdResponse.tuple',
        {
          id: '$..ID',
          orderId: '$..OrderID',
          mfdOrderLineItemId: '$..MFDOrderLineItemID',
          quantity: '$..Quantity',
          price: '$..Price',
          clin: '$..CLIN',
          volumeBand: '$..VolumeBand',
          isColor: '$..IsColor',
          isNipr: '$..IsNIPR',
          speedPPM: '$..speedPPM',
          optionalAccessories: '$..OptionalAccessories',
          additionalServices: '$..AdditionalServices',
          paperHandlingCapacity: '$..PaperCapacityHandling'
        }
      ]
    }
  });
  
  _.each(response.items, (item) => {
    item.formattedPrice =  parseInt(item.price).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
  })

  cleanUpResponse(response);
  return response.items;
}
